import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

/* ----------------------- VISITED ADVANCE STATE STORE ----------------------- */
/* 
used for indicating if the user has visited advance section
*/

type VisitedAdvanceState = {
  hasVisitedAdvance: boolean
}

type VisitedAdvanceAction = {
  updateHasVisitedAdvance: (s: boolean) => void
}

export const useVisitedAdvanceStore = create<
  VisitedAdvanceState & VisitedAdvanceAction
>()(
  persist(
    (set) => ({
      hasVisitedAdvance: false,
      updateHasVisitedAdvance: (state: boolean) =>
        set(() => ({ hasVisitedAdvance: state }))
    }),
    {
      name: 'has-visited-advance-state',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

/* ----------------------- VISITED LOAN STATE STORE ----------------------- */
/* 
used for indicating if the user has visited loan section
*/

type VisitedLoanState = {
  hasVisitedLoan: boolean
}

type VisitedLoanAction = {
  updateHasVisitedLoan: (s: boolean) => void
}

export const useVisitedLoanStore = create<
  VisitedLoanState & VisitedLoanAction
>()(
  persist(
    (set) => ({
      hasVisitedLoan: false,
      updateHasVisitedLoan: (state: boolean) =>
        set(() => ({ hasVisitedLoan: state }))
    }),
    {
      name: 'has-visited-loan-state',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

/* ----------------------------- SELECTED CREDIT TAB STORE ----------------------------- */
/* 
use for storing the selected tab index
*/

type SelectedCreditTabState = {
  selectedTab: number
}

type SelectedCreditTabAction = {
  updateSelectedTab: (id: number) => void
}

export const useSelectedCreditTabStore = create<
  SelectedCreditTabState & SelectedCreditTabAction
>()(
  persist(
    (set) => ({
      selectedTab: 0,
      updateSelectedTab: (id: number) => set(() => ({ selectedTab: id }))
    }),
    {
      name: 'credit-tab-id',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
